import { createHqHalfyearRepository, type HqHalfyearRepository } from './repository';

/** Reuses the current Firebase Auth/App Check app; unavailable configuration stays unavailable. */
export function createFirebaseHqHalfyearRepository(): HqHalfyearRepository | null {
  const config = {
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '',
  };
  if (
    import.meta.env.VITE_AUTH_ADAPTER !== 'firebase' ||
    Object.values(config).some((value) => !value.trim())
  )
    return null;
  const port = import('@kop/operations-firebase-adapter').then((module) =>
    module.createHqHalfyearReviewPort(config),
  );
  return createHqHalfyearRepository({
    load: async (input) => (await port).load(input),
    execute: async (input) => (await port).execute(input),
  });
}
